import { render, staticRenderFns } from "./RecAds.vue?vue&type=template&id=3dacdd68&"
import script from "./RecAds.vue?vue&type=script&lang=js&"
export * from "./RecAds.vue?vue&type=script&lang=js&"
import style0 from "./RecAds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports